export default __webpack_public_path__ + "static/media/book.9711d397.svg";